// src/store/themeAtom.js
import { atom } from "recoil";
import { app } from "@microsoft/teams-js";

const getTeamsTheme = async () => {
  try {
    await app.initialize();
    const context = await app.getContext();
    const theme = context?.app?.theme;
    if (theme === "dark") return "dark";
  } catch (err) {
    console.warn(
      "Not running inside Microsoft Teams or failed to get context."
    );
  }
  return "light";
};

const themeAtom = atom({
  key: "theme-mode",
  default: getTeamsTheme(), // fallback
  effects: [
    ({ setSelf, onSet }) => {
      getTeamsTheme().then(setSelf);

      const storedTheme = localStorage.getItem("theme-mode");
      if (storedTheme === "dark" || storedTheme === "light") {
        setSelf(storedTheme);
      }

      onSet((newValue) => {
        localStorage.setItem("theme-mode", newValue);
      });
    },
  ],
});

export default themeAtom;
